import React from 'react'
import {
  StyledImageDiv,
  StyledThumbnail,
  PlayButtonImage,
  Overlay,
} from '../style'
import hoverButton from '@assets/images/playbutton-hover.png'
import { useImageSrc } from '../../../hooks/useVideoSrc'

const UntoggledModal = ({
  width,
  align,
  margin,
  wrapText,
  thumbnail,
  handleModal,
}) => {
  const { imgSrc, handleImageError } = useImageSrc(thumbnail)
  const hoverPlayButtonImage = {
    fluid: {
      src: hoverButton,
    },
  }
  return (
    <StyledImageDiv
      relative
      align={align}
      width={width}
      wrapText={wrapText}
      margin={margin}
      className="qtph-modal-video"
    >
      <StyledThumbnail
        src={imgSrc}
        align={align}
        width={width}
        wrapText={wrapText}
        referrerPolicy="no-referrer"
        onError={handleImageError}
      />
      <PlayButtonImage
        src={hoverPlayButtonImage.fluid.src}
        onMouseDown={handleModal}
        aria-label="play"
        data-testid="play-modal"
      />
      <Overlay onMouseDown={handleModal} />
    </StyledImageDiv>
  )
}

export default UntoggledModal
